const env = {
  sentry: {
    environment: import.meta.env.PUBLIC_SENTRY_ENVIRONMENT,
  },
  gtm: import.meta.env.PUBLIC_GTM_ID,
  mixpanel: {
    token: import.meta.env.PUBLIC_MIXPANEL_PROJECT_TOKEN,
  },
  apiUrl: import.meta.env.PUBLIC_API_URL,
  appUrl: import.meta.env.PUBLIC_APP_URL,
  authUrl: import.meta.env.PUBLIC_AUTH_URL,
  cognitoClientId: import.meta.env.PUBLIC_COGNITO_CLIENT_ID,
  appVersion: import.meta.env.PUBLIC_APP_VERSION,
  messageRetrievalApiUrl: import.meta.env.PUBLIC_MESSAGE_RETREIVAL_API_URL,
  chatsUrl: import.meta.env.PUBLIC_CHATS_URL,
  googleDriveClientId: import.meta.env.PUBLIC_GOOGLE_DRIVE_CLIENT_ID,
  googleAppId: import.meta.env.PUBLIC_GOOGLE_APP_ID,
  dropboxClientId: import.meta.env.PUBLIC_DROPBOX_CLIENT_ID,
  stripePublishableKey: import.meta.env.PUBLIC_STRIPE_PUBLISHABLE_KEY,
};

export default env;
